import { render, staticRenderFns } from "./ExpandedMenuItem.vue?vue&type=template&id=66a84240&scoped=true"
import script from "./ExpandedMenuItem.vue?vue&type=script&lang=js"
export * from "./ExpandedMenuItem.vue?vue&type=script&lang=js"
import style0 from "./ExpandedMenuItem.vue?vue&type=style&index=0&id=66a84240&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a84240",
  null
  
)

export default component.exports